import { API_CORE_URL } from '../../constants/env';
import { apiSlice } from '../apiSlice';

export const realTimeTranslationSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createTranslation: builder.mutation({
      query: ({ orgId, targetLanguage, queryText }) => ({
        url: `organizations/${orgId}/translations/translate`,
        method: 'POST',
        body: {
          targetLanguage,
          messages: queryText
        },
        stringifyBody: true,
        API_URL: API_CORE_URL,
        errorMessage: {
          showMessage: true,
          messages: 'translate poopi'
        }
      })
    }),
    detectLanguage: builder.mutation({
      query: ({ orgId, queryText }) => ({
        url: `organizations/${orgId}/translations/detect`,
        method: 'POST',
        body: {
          messages: [queryText]
        },
        stringifyBody: true,
        API_URL: API_CORE_URL,
        errorMessage: {
          showMessage: true,
          messages: 'translate poopi'
        }
      })
    })
  })
});

export const {
  useCreateTranslationMutation,
  useDetectLanguageMutation
} = realTimeTranslationSlice;
